import {ValueItemConfig} from 'filters/features/FilterTopbar/types';
import {assertPageFilter} from 'filters/types';

import {useFilterLoading, useSourceFilter} from 'filters/contexts/FilterStackProvider';
import {useFilterActionsContext} from 'filters/contexts/FilterActionsProvider/FilterActionsProvider';

import {BaseFilterTopBarItem} from 'modules/decisionsNext/components/BaseFilter/TopBar/BaseFilterTopBarItem';

export const createValueItem = <V,>(config: Omit<ValueItemConfig<V>, 'type'>): ValueItemConfig<V> => {
  return {
    ...config,
    type: 'value',
  };
};

export const ValueItem = ({disabled, variant, getValue, getTooltip, onClick, onReset}: ValueItemConfig<any>) => {
  const filter = useSourceFilter();
  const loading = useFilterLoading();
  const {useApplyFilter} = useFilterActionsContext();
  const onApply = useApplyFilter();
  const value = getValue(filter);

  if (!value) {
    return null;
  }

  return (
    <BaseFilterTopBarItem
      disabled={disabled}
      variant={variant}
      label={value}
      loading={loading}
      tooltip={getTooltip?.(filter, value)}
      onClick={onClick}
      onDelete={
        onReset
          ? () => {
              assertPageFilter(filter);
              onApply(onReset(filter));
            }
          : undefined
      }
    />
  );
};
